import { TmBaseError } from '@/core/error/tmBaseError'

export class TmDomainError extends TmBaseError {
  public name = 'TmDomainError'
}
